import { showNotification } from '@/services/calculate'
import { socketEvents, checkEvents } from '@/services/config'
import levels from '@/components/DynamicComponents/Projects/Navigation/ActualCost/level'

export default {
  props: [
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'projectModule',
    'child',
  ],
  components: {
    'add-level': levels,
  },
  beforeMount() {},
  created() {
    this.$socketHub.$on('message-received', this.recievedMessage)
  },
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    // Common Method Start //
    calculateLevelTotal(total, assetId) {
      this.$emit('calulateParentLevelTotal', total, assetId)
    },

    setLevels(level) {
      this.$emit('storeLevels', level)
    },

    downloadTemplate(id) {
      this.$emit('exportTemplate', id)
    },

    // Common Method End //

    // Socket Section Start //
    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      }
      if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.estimateTakeoffUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.$root.$emit('updateAdjustmentTakeoff', message)
        this.$root.$emit('onUpdateAdjustmentTakeoff', message)
        this.$root.$emit('onLinkTakeoffs', message)
      } else if (data.EventType === socketEvents.takeoffMoved) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.$root.$emit('onLinkTakeoff', data)
        this.$root.$emit('onLevelLinkTakeoff', data)
        this.$root.$emit('onMoveTakeoffs', message)
      } else if (data.EventType === socketEvents.tileMoved) {
        this.$root.$emit('popupUpdation', false, true, null)
        this.$root.$emit('onMoveTiles', message)
      } else if (data.EventType === socketEvents.error) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result)
      }
    },
    // Socket Section End //
  },
}
